<template>
  <div>

    <!-- Alert: No item found -->
    <b-alert
      variant="success"
      :show="!userData"
    >
      <h4 class="alert-heading">
        Data is loading...
      </h4>
    </b-alert>

    <template v-if="userData">
      <!-- First Row -->
      <b-row>
        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
        >
          <b-card
            no-body
            class="card-employee-task"
          >
            <b-card-header
              class="details-header"
            >
              <b-card-title>
                {{ $t('DEBTIA_CLIENT_DETAILS') }}
                :
                <small
                  title="Copy Client ID"
                  style="cursor: pointer;"
                  @click.stop.prevent="copyCode('copy-client-id')"
                >{{ userData.data.id }}
                  <input
                    id="copy-client-id"
                    type="hidden"
                    :value="userData.data.id"
                  >
                </small> |
                <small
                  title="Copy Creditor ID"
                  style="cursor: pointer;"
                  @click.stop.prevent="copyCode('copy-bc-creditor-id')"
                >
                  {{ userData.data.bc_creditor_id }}
                  <input
                    id="copy-bc-creditor-id"
                    type="hidden"
                    :value="userData.data.bc_creditor_id"
                  >
                </small> {{ userData.data.bc_customer_id ? '|' : '' }}
                <small
                  title="Copy Customer ID"
                  style="cursor: pointer;"
                  @click.stop.prevent="copyCode('copy-bc-customer-id')"
                >
                  {{ userData.data.bc_customer_id }}
                  <input
                    id="copy-bc-customer-id"
                    type="hidden"
                    :value="userData.data.bc_customer_id"
                  >
                </small>
              </b-card-title>
              <b-button
                :to="{ name: 'client-edit', params: { id: userData.data.id } }"
                variant="primary"
              >
                {{ $t('DEBTIA_EDIT_CLIENT') }}
              </b-button>
            </b-card-header>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
        >
          <user-view-user-info-card :user-data="userData" />
        </b-col>
      </b-row>

      <b-row>
        <b-col
          cols="12"
          lg="12"
        >
          <client-details-portion :user-data="userData" />
        </b-col>
      </b-row>
    </template>

  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BRow, BCol, BAlert,
  // BLink,
  BCard, BCardHeader, BCardTitle, BButton,
} from 'bootstrap-vue'
// import InvoiceList from '@/views/apps/invoice/invoice-list/InvoiceList.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { EventBus } from '@/event-bus'
import clientStoreModule from '../clientStoreModule'
import UserViewUserInfoCard from './UserViewUserInfoCard.vue'
import ClientDetailsPortion from './ClientDetailsPortion.vue'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    // BLink,
    BCard,
    BCardHeader,
    BCardTitle,
    BButton,
    // Local Components
    UserViewUserInfoCard,
    ClientDetailsPortion,
    // InvoiceList,
  },
  data() {
    return {
      InvoiceList: [],
    }
  },
  created() {
    EventBus.$on('client-updated', this.fetchClientData)
  },
  setup() {
    const userData = ref(null)

    const USER_APP_STORE_MODULE_NAME = 'app-client'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, clientStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const fetchClientData = async () => {
      const { id } = router.currentRoute.params
      try {
        const response = await store.dispatch('app-client/fetchClient', { id })
        userData.value = response.data
      } catch (error) {
        if (error.response.status === 404) {
          userData.value = undefined
        }
      }
    }

    fetchClientData()

    return {
      userData,
      fetchClientData,
    }
  },
  methods: {
    copyCode(id) {
      let codeToCopy = ''
      codeToCopy = document.querySelector(`#${id}`)
      codeToCopy.setAttribute('type', 'text')
      codeToCopy.select()
      try {
        document.execCommand('copy')

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Text copied',
            icon: 'BellIcon',
          },
        })
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Failed to copy texts!',
            icon: 'BellIcon',
          },
        })
      }
      /* unselect the range */
      codeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
  },
}
</script>

<style>
.details-header {
  padding: 10px 15px 10px 15px !important;
}
</style>
